import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "system-header" }
const _hoisted_3 = { class: "system-title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "avatar" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 0,
  class: "sender"
}
const _hoisted_10 = { class: "admin-actions" }
const _hoisted_11 = { class: "message-content" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message admin", [
      { mine: _ctx.message.user.id === _ctx.user.id },
      { system: _ctx.message.type === 'system' },
    ]])
  }, [
    (_ctx.message.type === 'system')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "system-message",
          id: `messages-${_ctx.message.id}`
        }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "system-icon" }, "📢", -1)),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.message.title || "System Announcement"), 1)
          ]),
          _createElementVNode("div", {
            class: "system-content",
            innerHTML: _ctx.decodeMessage(_ctx.message.message)
          }, null, 8, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.timeString), 1)
        ], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isPrevMessageUserSame)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.message.user.avatar,
                  alt: "avatar"
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "message-body",
            id: `messages-${_ctx.message.id}`
          }, [
            (_ctx.isLastMessageFromSameUser && _ctx.user.id !== _ctx.message.user.id)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.message.user.name), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Tooltip, { text: "Delete message" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete', _ctx.message)))
                  }, "🗑")
                ]),
                _: 1
              }),
              _createVNode(_component_Tooltip, { text: "Mute user" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('mute', _ctx.message.user)))
                  }, "🔇")
                ]),
                _: 1
              }),
              _createVNode(_component_Tooltip, { text: "Block user" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('block', _ctx.message.user)))
                  }, "⛔")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", {
                innerHTML: _ctx.decodeMessage(_ctx.message.message),
                class: _normalizeClass([{
              'message-own': _ctx.user.id === _ctx.message.user.id,
            }, "message-over"])
              }, null, 10, _hoisted_12)
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.timeString), 1)
          ], 8, _hoisted_8)
        ], 64))
  ], 2))
}